// extracted by mini-css-extract-plugin
export var avatarContainer = "_54-1";
export var largeAvatarContainer = "_54-2";
export var smallAvatarContainer = "_54-0";